import React from 'react';
import './style.css';
import users from '../../../../services/users/index';
//import userThumbnail from '../../../../user.png';
const images = require("../../../../images.json");
const userThumbnail = images.user

export default class ConfigComponent extends React.Component {
    state = {
        file: null,
        fileUrl: ""
    }

    onChange = (e) => {
        if(e.target.files.length > 0) {
            e.persist();
            let file = e.target.files[0];

            let isImage = file.type.includes("image/")

            if(isImage) {
                var fr = new FileReader();
                fr.onload = () => {
                    this.setState({fileUrl: fr.result, file: file});
                }
                fr.readAsDataURL(file);
            }
        }
    }

    get filename() {
        return this.state.file ? this.state.file.name : "";
    }

    updateUser = () => {
        users.update({_id: this.props.user._id}, {$set: {image: this.state.fileUrl}}, () => {
            let newUser = Object.assign({}, this.props.user);
            newUser["image"] = this.state.fileUrl;
            this.props.updateUser(newUser);
        })
    }

    get userImage() {
        if(this.state.fileUrl)
            return this.state.fileUrl;
        if(this.props.user.image)
            return this.props.user.image;

        return userThumbnail;
    }

    render() {
        return (
            <div className="Config">
                <div className="card">
                    <div className="card-header">
                        <h2 className="card-header-title">
                            Cambiar foto
                        </h2>
                    </div>
                    <div className="card-content">
                        <div className="card-content-wrapper">
                            <div className="image-side">
                                <figure className="image is-128x128 rounded">
                                    <img alt="avatar"
                                        src={this.userImage} />
                                </figure>
                                <b>{this.props.user.userName}</b>
                            </div>
                            <div className="file-side">
                                <div className="field">
                                    <div className="file is-link has-name is-boxed">
                                        <label className="file-label">
                                            <input onChange={this.onChange}
                                                className="file-input"
                                                type="file"
                                                name="file"
                                            />
                                            <span className="file-cta">
                                                <span className="file-icon">
                                                    <i className="fas fa-cloud-upload-alt"></i>
                                                </span>
                                                <span className="file-label">
                                                    Subir archivo...
                                                </span>
                                            </span>
                                            {this.filename &&
                                            <span className="file-name">
                                                {this.filename}
                                            </span>}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer"
                        style={{display: "flex", justifyContent: "flex-end", padding: 5, paddingRight: 15}}
                    >
                        <button onClick={this.updateUser} className="button is-primary">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/config/index.js